import {
    FETCH_SCHEMASELECTION_REQUEST,
    FETCH_SCHEMASELECTION_FAILURE,
    FETCH_SCHEMASELECTION_SUCCESS
} from "./actionTypes";

import { SchemaSelectionActions, SchemaSelectionState } from "./types";

const initialState: SchemaSelectionState = {
    pending: false,
    schemaSelection: [],
    error: null,
};

export const SchemaSelectionReducer =  (state = initialState, action: SchemaSelectionActions) => {
    switch (action.type) {
        case FETCH_SCHEMASELECTION_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case FETCH_SCHEMASELECTION_SUCCESS:
            return {
                ...state,
                pending: false,
                schemaSelection: action.payload.schemaSelection,
                error: null,
            };
        case FETCH_SCHEMASELECTION_FAILURE:
            return {
                ...state,
                pending: false,
                schemaSelection: [],
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

export default SchemaSelectionReducer;